export class FacturaConsumoAgua{
    constructor(
        public cliente: any = null,
        public facturas: any[] = [],
        public cuotas: any[] = [],
        public otrosIngresos: any[] = []
    ) {
    }
}